export default {
  computed: {
    routes() {
      return {
        [this.routeName.DASHBOARD]: {
          route: this.routeName.DASHBOARD,
          icon: 'icon-dashboard',
          exact: true,
          condition: this.permissions.navigation[this.routeName.DASHBOARD]
        },
        [this.routeName.VOUCHERS]: {
          route: this.routeName.VOUCHERS,
          icon: 'icon-vouchers',
          condition: true
        },
        [this.routeName.DEBTORS]: {
          route: this.routeName.DEBTORS,
          icon: 'icon-clients',
          condition: true
        },
        [this.routeName.PERMANENT_DEBTS]: {
          route: this.routeName.PERMANENT_DEBTS,
          icon: 'icon-permanent-debt',
          condition: this.permissions.navigation[this.routeName.PERMANENT_DEBTS]
        },
        [this.routeName.UNPROCESSED]: {
          route: this.routeName.UNPROCESSED,
          icon: 'icon-hourglass',
          condition: this.permissions.navigation[this.routeName.UNPROCESSED]
        },
        [this.$t('upload.title')]: {
          name: this.$t('upload.title'),
          action: this.openVoucherUploadDialog,
          icon: 'icon-plus',
          condition: this.permissions.vouchers.upload
        }
      };
    },

    defaultRoute() {
      return Object.values(this.routes).find((route) => route.route && route.condition !== false);
    }
  }
};
